export const getColorCode = (color) => {
  if (!color) return "#e5e7eb"; // fallback gray

  const key = color.toLowerCase().replace(/\s|-/g, "");

  return colorMap[key] || "#d1d5db";
};

const colorMap = {
  red: "#ef4444",
  maroon: "#800000",
  blue: "#3b82f6",
  green: "#22c55e",
  black: "#000000",
  white: "#ffffff",
  yellow: "#eab308",
  orange: "#f97316",
  pink: "#ec4899",
  purple: "#a855f7",
  gray: "#6b7280",
  lightgray: "#d1d5db",
  darkgray: "#374151",
  cyan: "#06b6d4",
  teal: "#14b8a6",
  lime: "#84cc16",
  indigo: "#6366f1",
  violet: "#8b5cf6",
  fuchsia: "#d946ef",
  rose: "#f43f5e",
  amber: "#f59e0b",
  emerald: "#10b981",
  skyblue: "#0ea5e9",
  navy: "#1e3a8a",
  olive: "#808000",
  gold: "#ffd700",
  silver: "#c0c0c0",
  beige: "#f5f5dc",
  brown: "#8b4513",
  chocolate: "#7b3f00",
  coral: "#ff7f50",
  salmon: "#fa8072",
  khaki: "#f0e68c",
  plum: "#dda0dd",
  turquoise: "#40e0d0",
};
